import { render, staticRenderFns } from "./EditSpaceOwner.vue?vue&type=template&id=ae4d020a"
import script from "./EditSpaceOwner.vue?vue&type=script&lang=js"
export * from "./EditSpaceOwner.vue?vue&type=script&lang=js"
import style0 from "./EditSpaceOwner.vue?vue&type=style&index=0&id=ae4d020a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports